import TaskLaneColumn from './TaskLaneColumn';

export default TaskLaneColumn;
